// extracted by mini-css-extract-plugin
export default {"title":"title-pDiOF","number":"number-zVKPf","textContainer":"textContainer-hUfCg","buttonContainer":"buttonContainer-Uzg6a","infoContainer":"infoContainer-ZiwE1"};